import { useState, useEffect } from 'react';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';

import { Reviews } from './Reviews';
import { InfoServices } from './Services';
import { InfoDesc } from './Desc';
import { InfoOffers } from './Offers';
import { ImageCategoryTile } from './ImageCategoryTile';
import { InfoSummary } from './InfoSummary';
import { ThingsKnow } from './ThingsKnow';
import { StarIcon } from '@/component/Icons/StarIcon';

import { InfoDateRange } from './DateRange';

const DynamicMap = dynamic(() => import('./GoogleMap'), {
  ssr: false,
  loading: () => <div />,
});

export const ListingDetailsInfo = ({
  priceStartDate,
  locationName,
  priceEndDate,
  daysAmount,
  details,
  priceLoading,
  startTransition,
}) => {
  const t = useTranslations();
  const [hydrated, setIsHydrated] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  return (
    <div className="listing-wrap lg:pt-3">
      {details.headline && (
        <h2 className="text-slate-700 max-sm:text-base text-2xl font-semibold tracking-tight lg:pr-8">
          {details.headline}
        </h2>
      )}

      <div className="flex flex-col gap-4 pb-8">
        <InfoServices occupancy={details.occupancy} />

        {details.numReviews > 0 && (
          <div className="flex items-center text-slate-500 text-base gap-1">
            <StarIcon />
            <span>{details.ratingScore}</span>
            <button className="lowercase" onClick={() => setIsOpen(true)}>
              ({details.numReviews} {t('apartment.rating.sub-title')})
            </button>
          </div>
        )}
      </div>

      <InfoSummary amenities={details.featuredAmenities} />

      <InfoDesc description={details.description} />

      {details.imageCategories?.length !== 0 &&
        details.imageCategories?.[0].images?.[0] && (
          <div className="pb-2 border-t border-slate-300">
            <div className="flex overflow-auto w-full gap-6 !py-8 scrollbar-thin scrollbar-thumb-slate-400 scrollbar-track-transparent scrollbar-thumb-rounded">
              {details.imageCategories.map((item, i) => (
                <ImageCategoryTile key={i} imageCategory={item} />
              ))}
            </div>
          </div>
        )}

      <InfoOffers amenities={details.regularAmenities} />
      {details?.numReviews > 0 && (
        <Reviews
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          rating={details.ratingScore}
          reviews={details.reviews}
        />
      )}

      {hydrated ? (
        <InfoDateRange
          key={`${priceStartDate}-${priceEndDate}`}
          priceStartDate={priceStartDate}
          priceEndDate={priceEndDate}
          daysAmount={daysAmount}
          city={locationName}
          calendar={details.calendar}
          priceLoading={priceLoading}
          startTransition={startTransition}
        />
      ) : null}

      <DynamicMap location={details.location} />

      <ThingsKnow
        houseRules={details.houseRules}
        cancellationPolicy={details.cancellationPolicy}
      />
    </div>
  );
};
